import React from 'react';

const LayoutPublic: React.FC = (props: { children?: React.ReactNode }) => {
  return <div className='container vh-100'>{props.children}</div>;
};

export default LayoutPublic;
